// Session helper supporting "Ricordami".
// The token always lives in localStorage (letto direttamente da molti componenti).
// Quando "Ricordami" è disattivo marchiamo la sessione come "solo sessione":
// alla chiusura del browser sessionStorage viene svuotato e al riavvio la sessione scade.

export const getToken = () => localStorage.getItem('token');

export const getUser = () => {
  const raw = localStorage.getItem('user');
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
};

export const setSession = (token, user, remember) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  if (remember) {
    localStorage.removeItem('sess_only');
    sessionStorage.removeItem('sess_alive');
  } else {
    localStorage.setItem('sess_only', '1');
    sessionStorage.setItem('sess_alive', '1');
  }
};

export const updateStoredUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('sess_only');
  sessionStorage.removeItem('sess_alive');
};

// Chiamato all'avvio dell'app: forza la scadenza per i login "solo sessione".
// Ritorna true se la sessione è stata fatta scadere.
export const enforceSessionExpiry = () => {
  if (localStorage.getItem('sess_only') === '1' && sessionStorage.getItem('sess_alive') !== '1') {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('sess_only');
    return true;
  }
  if (localStorage.getItem('sess_only') === '1') {
    sessionStorage.setItem('sess_alive', '1');
  }
  return false;
};
